import { Col, Row } from 'react-bootstrap';
import type { LeadCloudFileType } from '@econtractor/types';
import FolderItem from './FolderItem';
import type { FilesViewMode } from './model/filesView';

interface FoldersListProps {
    folders: LeadCloudFileType[];
    view: FilesViewMode;
    canDelete?: boolean;
    deletingKey?: string | null;
    renamingKey?: string | null;
    onOpen: (folder: LeadCloudFileType) => void;
    onDelete?: (folder: LeadCloudFileType) => void;
    onRename?: (folder: LeadCloudFileType) => void;
    canDrag?: boolean;
    movingKey?: string | null;
}

const FoldersList = ({
    folders,
    view,
    canDelete,
    deletingKey,
    renamingKey,
    onOpen,
    onDelete,
    onRename,
    canDrag,
    movingKey,
}: FoldersListProps) => {
    if (!folders.length) return null;

    const colProps = view === 'list' ? { xs: 12 } : { xs: 12, sm: 6 };

    return (
        <Row>
            {folders.map((folder) => (
                <Col key={folder.storageKey || folder.folderPath} className="p-1" {...colProps}>
                    <FolderItem
                        folder={folder}
                        busy={
                            deletingKey === folder.storageKey ||
                            renamingKey === folder.storageKey ||
                            movingKey === folder.storageKey
                        }
                        canDelete={canDelete}
                        onOpen={onOpen}
                        onDelete={onDelete}
                        onRename={onRename}
                        canDrag={canDrag}
                    />
                </Col>
            ))}
        </Row>
    );
};

export default FoldersList;
